
/* injects from baggage-loader */
require('./style.scss');

import React, { useState } from "react";
import { connect } from "react-redux";
import KeyboardInput from "../InputKeyboard";
import { t } from "../../../helpers/translator";
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import userPic from '../../../images/user.png'
import { depositToClientAccount } from "../../../actions/terminal";
const TransferToAccount = ({ client, dispatch }) => {
    const [amount, setAmount] = useState('');
    const handleChange = (value) => {
        const valMoney = /^[0-9]*$/;
        
        if(valMoney.test(value)) {
            setAmount(value)
        }
    }
    return (
        <div className='transfer-to-account-details-container'>
            <div className='transfer-to-account-details-title'>{t("Transfer to Account")}</div>
            <div className='client-info'>
                <img alt='user-icon' src={userPic}/>
                <div>
                    <p>{ client.FirstName } { client.LastName }</p>
                    <p>{ client.Id }</p>
                </div>
            </div>
            {/* <div className='client-input-container'>
                <p>{t("Transfer Amount")}</p>
                <KeyboardInput
                    numeric
                    type='text'
                    value={amount}
                    onChange={handleChange}
                />
            </div> */}
            <div className='buttons-container'>
            <button
                className='button-view-normal-m cancel'
                onClick={() => dispatch(ClosePopup(true))}>
                    Cancel
            </button>
            <button
                className='button-view-normal-m'
                onClick={() => dispatch(depositToClientAccount(client.Id))}
            >
                Submit
            </button>
            </div>
        </div>
    )
}
export default connect()(TransferToAccount)
// props.dispatch(OpenPopup(
//     'successPopup',
//     {
//         title: 'Transfer to Account',
//         subTitle: 'The transfer was successfully done.\nPlease take your ticket'
//     }
// ))